import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useAssignSubGroupClub = (groupId?: string) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation('assignSubGroupClub', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: ['subGroups'] });
      await queryClient.invalidateQueries({ queryKey: ['sub-group-club-gallery'] });
      await revalidate(['searchGroups', 'all']);

      if (groupId) {
        await queryClient.invalidateQueries({ queryKey: ['groups', 'detail', groupId] });
        await revalidate(['searchGroups', 'all']);
      }
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsync, isPending };
};

export default useAssignSubGroupClub;
